export const optionsValue = {
    skip: 0,
    accept: 1,
    decline: 2
};
